// List of errors that the system has notice of handling

module.exports = ['404', '504', '500', '501', '403', '401'] 